// extracted by mini-css-extract-plugin
export default {"tagList":"tagList__jukBqT","roleTag":"roleTag__de9CyO","roleLabel":"roleLabel__YAQfwy"};